import { schemaTypes } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";

const nameMapping = [
  { key: "enginehours", value: "Machine HMR", unit: "Hrs" },
  {
    key: "highgeartraveldistance",
    value: "High Gear Travel Distance",
    unit: "Km",
  },
  { key: "highgeartraveltime", value: "High Gear Travel Time", unit: "min" },
  { key: "idletraveltime", value: "Idle Travel Time", unit: "min" },
  {
    key: "lowgeartraveldistance",
    value: "Low Gear Travel Distance",
    unit: "Km",
  },
  { key: "lowgeartraveltime", value: "Low Gear Travel Time", unit: "min" },
  { key: "pavingdistance", value: "Paving Distance", unit: "Km" },
  { key: "pavingtime", value: "Paving Time", unit: "min" },
  { key: "pavingwithheatingtime", value: "Paving W/ Heating", unit: "min" },
  { key: "pavingwithoutheatingtime", value: "Paving W/O Heating", unit: "min" },
];

const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];

  for (let idx in nameMapping) {
    if (!(nameMapping[idx].key in respObj)) continue;

    historyData.push({
      alarm: nameMapping[idx].value,
      count:
        respObj[nameMapping[idx].key] +
        (nameMapping[idx].unit ? " " + nameMapping[idx].unit : ""),
    });
  }

  callback(historyData);
};

class PaverReport {
  constructor() {
    this.finalData = null;
  }

  getHistory = (schema, data, store) => {
    let saveState = null;
    let tableStateData = null;

    if (data.vehicle && data.vehicle.length) {
      if (window.setReportWindowTabBusy) {
        window.setReportWindowTabBusy(schema.key, true);
      }

      const handleSuccess = (resp) => {
        if (window.setReportWindowTabBusy) {
          window.setReportWindowTabBusy(schema.key, false);
        }

        processData(resp, store.vehicleMap, (processedData) => {
          this.finalData = processedData;

          if (tableStateData && tableStateData[0]) {
            tableStateData[0].body = processedData;
            tableStateData[0].busy = false;
            saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
          }

          if (schema.content[0].ref) {
            schema.content[0].ref.setData(processedData);
          }
        });
      };

      if (schema.content[0].ref) {
        schema.content[0].ref.setBusy(true);
        saveState = schema.content[0].ref.props.saveState;
        tableStateData = [
          schema.content[0].ref.state,
          schema.content[0].ref.props.schemaKey,
          schema.content[0].ref.props.data,
        ];
      }

      const body = {
        vehicleid: data.vehicle.map((item) => item.data.vehicleid),
        starttime: data.starttime.unix() * 1000,
        endtime: data.endtime.unix() * 1000,
      };

      if (window.showNoGpsFixData === true) {
        body.fixqfilter = false;
      }

      ReportAPIs.getPaverPopupMetrics(body).then(handleSuccess, () =>
        handleSuccess({})
      );
    } else {
      console.log("Please select at least one vehicle");
    }
  };

  downloadReport = () => {
    if (this.finalData) {
      JSONToCSVConvertor(this.finalData, "ViewReport", false);
    }
  };
}

const paverReportInstance = new PaverReport();

const schema = {
  key: "paver_report",
  name: "Paver",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      singleSelect: true,
      storeData: (state) => ({
        data: (() => {
          let newMap = {};
          for (let idx in state.vehicleMap) {
            if (idx.indexOf("user") === -1) {
              newMap[idx] = state.vehicleMap[idx];
            }
          }
          return newMap;
        })(),
        name: "vehicleno",
        id: "vehicleid",
      }),
      onItemChange: (v) => window.saveVehicleState(v),
      defaultValue: () => ({
        data: window.selectedVehicles.map((i) => i.id),
        updatedAt: window.selectedVehiclesUpdatedAt,
      }),
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Daily Report",
      onClick: paverReportInstance.getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: paverReportInstance.downloadReport,
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "alarm", name: "Name" },
        { key: "count", name: "Count" },
      ],
    },
  ],
};

export default schema;
